export enum IMPORT_EXCEL_STORAGE_KEYS {
  IMPORTED_EXCEL_SHEETS_STATUS = 'IMPORTED_EXCEL_SHEETS_STATUS',
  EXCEL_LAST_SYNCED_TIME = 'EXCEL_LAST_SYNCED_TIME',
}

export enum USER_STATUS_STORAGE_KEYS {
  LAST_OFFLINE_SYNCED_TIME = 'LAST_OFFLINE_SYNCED_TIME',
}
